export const UPLOAD_RESULTS_SUCCESS = 'UPLOAD_RESULTS_SUCCESS';

export const uploadResultsSuccess = () => ({
    type: UPLOAD_RESULTS_SUCCESS,
});
